































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GPageBase } from '@/mixins';
import { GradeSchoolClass, SchoolClassSelection } from '@/models/school-class/school-class';
import { SchoolClass } from '@/models/school-class/school-class';

@Component({
  name: 'GSchoolClassCheckboxes',
})
export default class GSchoolClassCheckboxes extends mixins(GPageBase) {
  @Prop() public gradeSchoolClasses: GradeSchoolClass[];
  @Prop() public selectionSchoolClasses: SchoolClassSelection[];
  @Prop() public isDisabled: boolean;

  gradeLabel(index: number, schoolClasses: SchoolClass[]): any {
    if (this.selectionSchoolClasses[index] === undefined) {
      return;
    }
    return (h: any) => {
      return h('div', [
        h('span', this.gradeSchoolClasses[index].grade + this.$t('YEAR').toString()),
        h('Badge', {
          props: {
            type: 'primary',
            count: this.selectionSchoolClasses[index].notSelectedIDs(schoolClasses).length,
          },
        }),
      ]);
    };
  }

  handleCheckBox(index: number, schoolClasses: SchoolClass[]) {
    this.selectionSchoolClasses[index].handleCheckAllGroupChange(schoolClasses);
    this.$emit('input', this.selectionSchoolClasses);
  }

  handleCheckAll(index: number, schoolClasses: SchoolClass[]) {
    this.selectionSchoolClasses[index].handleCheckAll(schoolClasses);
    this.$emit('input', this.selectionSchoolClasses);
  }
}
